
export const paginationStyle = theme => ({
    contentInitalTextSearch: {
        textAlign: 'center'
    }
})